import styled from 'styled-components';
import { fontFamilyHeading, dynamicFontSize } from './helpers/mixins';
import { color, size } from './helpers/variables';

export const HtmlWrapper = styled.div`
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  li {
    font-weight: normal;
    line-height: 1.714;
    text-align: left;
    margin: ${props => (props.mobileMargin ? '.5em 0 2em' : '1.5em 0')};
    color: ${color.black};
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    margin-bottom: 0;
  }

  h1 {
    ${fontFamilyHeading};
    ${dynamicFontSize(24, 32, size.small, size.medium)};
    font-weight: normal;
  }

  h2 {
    ${dynamicFontSize(16, 18, size.small, size.medium)};
    margin-bottom: 0.277em;
    font-weight: 600;
  }

  h3 {
    ${dynamicFontSize(16, 18, size.small, size.medium)};
    font-size: 1em;
  }

  h4 {
    ${dynamicFontSize(14, 16, size.small, size.medium)};
    font-size: 16px;
  }

  h5 {
    ${dynamicFontSize(12, 14, size.small, size.medium)};
    font-size: 14px;
  }

  h6 {
    font-size: 12px;
  }

  p,
  li {
    ${dynamicFontSize(14, 16, size.small, size.medium)};
    margin-top: 0;
  }

  ul,
  ol {
    margin: 1.5em 0;
  }

  li {
    margin-bottom: 0.5em;
  }

  a {
    color: ${color.primaryDark};
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote,
  .blockquote {
    ${fontFamilyHeading};
    ${dynamicFontSize(22, 32)};
    margin: 2em 0;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #000000;

    &:after {
      content: '';
      display: block;
      margin-top: 40px;
      height: 1px;
      width: 150px;
      background-color: #979797;
    }
  }

  iframe {
    max-width: 100%;
    height: auto;
  }

  .video-wrapper,
  .youtube-container {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; //value from (9 / 16) for standard youtube aspect ratio
    position: relative;
    margin: 34px 0;
    cursor: pointer;

    iframe {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/styles/HtmlWrapper.js